import { getMenuItem } from "../../../services";
import { Icon } from "../../icons";
import { Link } from "react-router-dom";

const MenuItemUser = (props) => {
  const { menu } = props;
  const menuItem = getMenuItem(menu, "user");
  const renderTitle = (title) => {
    const parts = title.split("マスタ");
    let before = parts[0] + "マスタ";
    let after = parts[1];
    return (
      <>
        {before}
        <span className="break-all inline-block">{after}</span>
      </>
    );
  };

  return (
    <div className="group bg-white border border-[#e0e0e0] rounded-[8px] max-w-[340px]">
      <div className="flex flex-col items-center 2xl:py-[20px] xl:py-[16px] py-[12px] lg:px-5 px-2">
        <Link to={menuItem.link} className="w-full">
          <div className="flex items-center mb-3 pl-1 lg:pl-5 2xl:pl-8 space-x-2">
            <Icon
              name={menuItem.icon}
              className="xl:w-[68px] xl:h-[68px] w-[56px] h-[56px]"
            />
            <h3 className="xl:text-[18px] text-base font-bold group-hover:text-[#5293fa]">
              {renderTitle(menuItem.title)}
            </h3>
          </div>
          <p className="text-center xl:text-base text-[14px] group-hover:text-[#5293fa]">
            {menuItem.description}
          </p>
        </Link>
      </div>
    </div>
  );
};

export default MenuItemUser;
